/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
import React from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { Space, Drawer, Typography, Row, Col, Descriptions, Tag, Divider } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import EbzButton from 'components/EbzButton';
import { DrawerCloseIcon, CopyIcon } from 'utils/icons';
import { INVOICE_ON_HOLD_REASON_DICT, VERSION2_PAYOUT_REPORT_STATUS } from 'constants/status';
import EVENT_NAME from 'utils/const';
import trackingService from 'services/trackingService';
import payoutReportsAPI from 'services/payoutApi';
import { PARTNER_INVOICE_ON_HOLD } from 'pages/PayoutReportsListPage/const';
import PropTypes from 'prop-types';
import Alert from 'components/Alert';

function PayoutReportViewDetails({ viewMoreModal, handleViewDetails, currentView }) {
  const isDownloadPayoutReport = useSelector(
    (state) => state.user.planPermissions.can_download_transactions_payout_report
  );

  const handleDownloadReport = async (Uniqueid, Uniquekey) => {
    const response = await payoutReportsAPI.downloadS3Reports({
      unique_id: Uniqueid,
      unique_key: Uniquekey
    });

    if (response.success) {
      window.open(response.data.url);
    } else {
      console.log('something went wrong');
      Alert('something went wrong', 'Please contact support team for this', 'error');
    }
    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
      name: 'Payout Report Downloaded',
      'unique-key': Uniquekey,
      unique_id: Uniqueid
    });
  };

  return (
    <Drawer
      title={
        <Space
          direction="horizontal"
          style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
        >
          <Typography.Text style={{ fontSize: '19px' }}>Payout Details</Typography.Text>
          <DrawerCloseIcon
            style={{
              color: 'var(--color-primary)',
              cursor: 'pointer'
            }}
            onClick={handleViewDetails}
          />
        </Space>
      }
      placement="right"
      width={550}
      closable={false}
      open={viewMoreModal}
      onClose={handleViewDetails}
      rootClassName="payout-view-details-drawer"
    >
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <Space direction="horizontal" style={{ width: '100%', justifyContent: 'space-between' }}>
            <Typography.Text style={{ fontWeight: '700' }}>
              Payout ID -{' '}
              <Typography.Text
                copyable={{
                  icon: [
                    <CopyIcon style={{ color: 'var(--color-primary)' }} />,
                    <CheckOutlined style={{ color: 'var(--color-primary)' }} />
                  ],
                  onCopy: () => {
                    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
                      name: 'Copy Payout ID'
                    });
                  }
                }}
                style={{ fontWeight: '700' }}
              >
                {currentView?._id}
              </Typography.Text>
            </Typography.Text>
          </Space>
        </Col>
        <Col span={24}>
          <Descriptions column={1} bordered labelStyle={{ backgroundColor: '#FFFFFF' }}>
            <Descriptions.Item label="Status">
              {VERSION2_PAYOUT_REPORT_STATUS[currentView?.status] ? (
                <Tag
                  color={VERSION2_PAYOUT_REPORT_STATUS[currentView?.status].bgColor}
                  style={{
                    padding: '2px 13px',
                    color: VERSION2_PAYOUT_REPORT_STATUS[currentView?.status].color,
                    fontSize: '12px'
                  }}
                >
                  {VERSION2_PAYOUT_REPORT_STATUS[currentView?.status].label}
                </Tag>
              ) : (
                <Tag
                  color="#EBEBEB"
                  style={{ padding: '2px 13px', color: '#7B7B7B', fontSize: '12px' }}
                >
                  {currentView?.status}
                </Tag>
              )}
            </Descriptions.Item>

            {currentView?.hold_reason !== undefined &&
              currentView?.hold_reason !== null &&
              currentView?.invoice_status === PARTNER_INVOICE_ON_HOLD && (
                <Descriptions.Item label="Remarks">
                  {INVOICE_ON_HOLD_REASON_DICT[currentView?.hold_reason]
                    ? INVOICE_ON_HOLD_REASON_DICT[currentView?.hold_reason]
                    : currentView?.hold_reason}
                </Descriptions.Item>
              )}
            <Descriptions.Item label="Easebuzz GST">27AAVCS2699M1Z5</Descriptions.Item>

            <Descriptions.Item label="Reporting Duration">
              {`${dayjs(currentView?.payout_start_date).format('DD/MM/YYYY')} - ${dayjs(
                currentView?.payout_end_date
              ).format('DD/MM/YYYY')}`}
            </Descriptions.Item>
            <Descriptions.Item label="Generation Date">
              {dayjs(currentView?.payout_generation_date).format('DD/MM/YYYY')}
            </Descriptions.Item>

            <Descriptions.Item label="Commission Amount">
              <Typography.Text style={{ wordSpacing: '12px' }}>
                {currentView?.commission_amount}
              </Typography.Text>
            </Descriptions.Item>

            {currentView?.tds_amount !== undefined && currentView?.tds_amount !== null && (
              <Descriptions.Item label="TDS Amount">{currentView?.tds_amount}</Descriptions.Item>
            )}
            {currentView?.invoice_gst_amount !== undefined && (
              <Descriptions.Item label="GST Amount" padding="20px">
                <Typography.Text style={{ wordSpacing: '3px', display: 'flex', gap: '22px' }}>
                  {currentView?.invoice_gst_amount}
                  {currentView?.gst_status === 'ON_HOLD' && (
                    <Tag color="red" style={{ fontSize: '12px' }}>
                      ON HOLD
                    </Tag>
                  )}
                </Typography.Text>
              </Descriptions.Item>
            )}

            {currentView?.invoice_amount !== undefined && (
              <Descriptions.Item label="Invoice Amount">
                <Typography.Text style={{ wordSpacing: '12px' }}>
                  {currentView?.invoice_amount}
                </Typography.Text>
              </Descriptions.Item>
            )}

            {currentView?.paid_amount !== undefined && (
              <Descriptions.Item label="Paid Amount">
                <Typography.Text style={{ wordSpacing: '12px' }}>
                  {currentView?.paid_amount}
                </Typography.Text>
              </Descriptions.Item>
            )}

            {currentView?.partner_invoice_no !== undefined &&
              currentView?.partner_invoice_no !== null && (
                <Descriptions.Item label="Invoice Number">
                  {currentView?.partner_invoice_no}
                </Descriptions.Item>
              )}

            {isDownloadPayoutReport && (
              <Descriptions.Item label="Download Reports">
                <EbzButton
                  size="middle"
                  onClick={() => {
                    handleDownloadReport(currentView?._id, currentView?.merchant_report_url);
                  }}
                >
                  <span style={{ textDecoration: 'underline' }}>Commission Report</span>
                </EbzButton>
                <br />
                {currentView?.transaction_report_url !== null && (
                  <>
                    <EbzButton
                      size="middle"
                      onClick={() => {
                        handleDownloadReport(currentView?._id, currentView?.transaction_report_url);
                      }}
                      style={{ marginTop: '15px' }}
                    >
                      <span style={{ textDecoration: 'underline' }}>
                        Referralwise Performance Report
                      </span>
                    </EbzButton>
                    <br />
                    <EbzButton
                      size="middle"
                      onClick={() => {
                        handleDownloadReport(
                          currentView?._id,
                          currentView?.consolidated_transaction_report_url
                        );
                      }}
                      style={{ marginTop: '15px' }}
                    >
                      <span style={{ textDecoration: 'underline' }}>
                        Referral Consolidated Performance Report
                      </span>
                    </EbzButton>
                    <br />
                    {currentView?.payment_mode_wise_report_url !== null && (
                      <EbzButton
                        size="middle"
                        onClick={() => {
                          handleDownloadReport(
                            currentView?._id,
                            currentView?.payment_mode_wise_report_url
                          );
                        }}
                        style={{ marginTop: '15px' }}
                      >
                        <span style={{ textDecoration: 'underline' }}>
                          Payment Mode Wise Report
                        </span>
                      </EbzButton>
                    )}
                  </>
                )}
              </Descriptions.Item>
            )}
          </Descriptions>
        </Col>
      </Row>
    </Drawer>
  );
}

PayoutReportViewDetails.propTypes = {
  viewMoreModal: PropTypes.bool.isRequired,
  handleViewDetails: PropTypes.func.isRequired,
  currentView: PropTypes.instanceOf(Object).isRequired
};

export default PayoutReportViewDetails;
